<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import { activityIconFor } from 'dashboard/helper/planningEventAuditHistoryHelper';

const props = defineProps({
  item: { type: Object, required: true },
  showActor: { type: Boolean, default: true },
  showIcon: { type: Boolean, default: true },
  compact: { type: Boolean, default: false },
});

const iconMeta = computed(() => activityIconFor(props.item.icon));
const sentence = computed(() => props.item.sentence || props.item);

const showFromTo = computed(() => {
  const s = sentence.value;
  return Boolean(s.before && s.after);
});

const showAfterValue = computed(() => {
  const s = sentence.value;
  if (showFromTo.value) return false;
  return Boolean(s.after);
});

const showBeforeOnly = computed(() => {
  const s = sentence.value;
  if (showFromTo.value || showAfterValue.value) return false;
  return Boolean(s.before);
});
</script>

<template>
  <div class="flex gap-3 min-w-0 items-start">
    <div
      v-if="showIcon"
      class="relative flex size-8 shrink-0 items-center justify-center rounded-full"
      :class="iconMeta.className"
    >
      <Icon :icon="iconMeta.icon" class="size-3.5" />
    </div>
    <div class="min-w-0 flex-1 text-sm text-n-slate-11 leading-5">
      <p class="mb-0 break-words">
        <template v-if="showActor && sentence.actor">
          <span class="font-semibold text-n-slate-12">{{ sentence.actor }}</span>
          {{ ' ' }}
        </template>
        <span>{{ sentence.verb }}</span>
        <template v-if="sentence.target">
          {{ ' ' }}
          <span class="font-semibold text-n-slate-12">{{
            sentence.target
          }}</span>
        </template>
        <template v-if="showFromTo">
          {{ ' ' }}
          <span class="font-semibold text-n-slate-12">{{ sentence.before }}</span>
          {{ ' to ' }}
          <span class="font-semibold text-n-slate-12">{{ sentence.after }}</span>
        </template>
        <template v-else-if="showAfterValue">
          <template v-if="sentence.target">{{ ' to ' }}</template>
          <template v-else>{{ ' ' }}</template>
          <span class="font-semibold text-n-slate-12">{{ sentence.after }}</span>
        </template>
        <template v-else-if="showBeforeOnly">
          {{ ' ' }}
          <span class="font-semibold text-n-slate-12">{{
            sentence.before
          }}</span>
        </template>
        <template v-if="sentence.detail">
          {{ ' with reason ' }}
          <span class="font-semibold text-n-slate-12">{{
            sentence.detail
          }}</span>
        </template>
      </p>
      <slot />
    </div>
  </div>
</template>
